// extracted by mini-css-extract-plugin
export default {"keyVaLuePairContainer":"KeyValuePairShow_keyVaLuePairContainer__L0gh6","key":"KeyValuePairShow_key__d3jQ8","value":"KeyValuePairShow_value__I384a"};